import {call, put} from 'redux-saga/effects';
import {takeEvery} from 'redux-saga';
import UserCheckinApi from '../api';
import * as Actions from '../redux/actions';
import * as Types from '../redux/actionTypes';


export default function* userCheckinsFlow() {
  yield [
    takeEvery(Types.USER_CHECKINS_LIST_GET, getUserCheckinsList)
  ];
}

function* getUserCheckinsList(action) {
  const {params} = action;
  try {
    const response = yield call(UserCheckinApi.getUserCheckins, params);
    yield put(Actions.getUserCheckinsSuccess(response));
  } catch (error) {
    yield put(Actions.getUserCheckinsFailure(error));
  }
}



// WEBPACK FOOTER //
// ./shared/checkins/redux/sagas.js